module.exports = __webpack_public_path__ + "img/95ru.6a15ec60.png";